@use "../../sass/variables/colors";
@use "../../sass/variables/dimensions";

.ux-message-box {
  display: block;
  position: relative;
  width: 100%;

  &__container {
    border: 1px solid colors.$color-black;
    box-shadow: 0 5px 25px rgb(0 0 0 / 10%);
    display: flex;
    flex-direction: column;
    padding: 25px 30px;
    position: relative;

    @media (width >= 576px) {
      align-items: center;
      flex-direction: row;
      padding: 35px 40px;
    }

    @media (width >= 768px) {
      padding: 45px 50px;
    }

    @media (width >= 1024px) {
      padding: 50px 75px;
    }
  }

  &__close {
    cursor: pointer;
    height: 16px;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 16px;

    ux-icon {
      display: block;
    }
  }

  &__icon {
    display: flex;
    font-size: 60px;
    margin: 0 0 dimensions.$dim-30 0;

    @media (width >= 576px) {
      margin-bottom: 0;
      margin-right: dimensions.$dim-40;
    }
  }

  &__text {
    &-intro,
    &-headline,
    &-text {
      display: block;
    }

    &-intro {
      margin: 0 0 7px;
    }

    &-headline {
      margin: 0 0 dimensions.$dim-5 0;
    }

    &-text > p {
      margin: 0;
    }
  }

  &--error {
    .ux-message-box__container {
      border-color: colors.$color-red-error;
    }

    .ux-message-box__icon ux-icon,
    .ux-message-box__close ux-icon {
      color: colors.$color-red-error;
    }

    .ux-message-box__text-intro,
    .ux-message-box__text-headline,
    .ux-message-box__text-text,
    .ux-message-box__text-text a {
      color: colors.$color-red-error;
    }
  }

  &--warning {
    .ux-message-box__container {
      border-color: colors.$color-orange;
    }

    .ux-message-box__icon ux-icon,
    .ux-message-box__close ux-icon {
      color: colors.$color-orange;
    }

    .ux-message-box__text-intro,
    .ux-message-box__text-headline,
    .ux-message-box__text-text,
    .ux-message-box__text-text a {
      color: colors.$color-orange;
    }
  }

  &--info {
    .ux-message-box__container {
      border-color: colors.$color-blue-info;
    }

    .ux-message-box__icon ux-icon,
    .ux-message-box__close ux-icon {
      color: colors.$color-blue-info;
    }

    .ux-message-box__text-intro,
    .ux-message-box__text-headline,
    .ux-message-box__text-text,
    .ux-message-box__text-text a {
      color: colors.$color-blue-info;
    }
  }

  &--success {
    .ux-message-box__container {
      border-color: colors.$color-green-1;
    }

    .ux-message-box__icon ux-icon,
    .ux-message-box__close ux-icon {
      color: colors.$color-green-1;
    }

    .ux-message-box__text-intro,
    .ux-message-box__text-headline,
    .ux-message-box__text-text,
    .ux-message-box__text-text a {
      color: colors.$color-green-1;
    }
  }
}
